import { Box, Divider, Stack, Typography } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import CommonButton from "../../common/components/CommonButton";
import theme from "../../theme";
import { ExpierienceYears, UserTypeId } from "../../common/const";
import CommonCard from "../../common/components/CommonCard";
import { ChatBubbleOutlineOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../features/authSlice";
import { joinConversation } from "../../api/chatApi";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import { mentorsByStudent } from "../../api/mentorApi";
import CommonBookSession from "../../common/components/CommonBookSession";


const CoachType = {
    Assign: 'Assigned Mentor',
    AI: 'DCP AI Project Mentor'
}

const Tutor = ({
    projectData,
    fromMentor,
    studentId,
    coachData,
    setCoachData,
    setInitialData
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const [coachType, setCoachType] = useState(CoachType.Assign);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [open, setOpen] = useState(false);

    const getTutorData = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await mentorsByStudent(user?.student_id || studentId);
            const data = response.data.find((a) => a.mentor_profile_id === projectData?.mentor_profile_id);
            loadImageAsBlob(data?.mentor?.user?.avatar);
            setCoachData(data);
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    const loadImageAsBlob = async (avatarPath) => {
        try {
            const fullUrl = `${process.env.REACT_APP_BASE_URL}/file?bname=${avatarPath}&download=false`;
            const response = await fetch(fullUrl, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const blob = await response.blob();
            const objectUrl = URL.createObjectURL(blob);
            setPreviewUrl(objectUrl);
        } catch (error) {
            console.error('Error loading image:', error);
        }
    };


    useEffect(() => {
        if ((user?.student_id || studentId) && projectData?.project_id) {
            getTutorData();
        }
    }, [user, projectData?.project_id, studentId]);

    return (
        projectData?.mentor_profile_id ? (
            <Fragment>
                <CommonCard
                    paddingBottom="0px"
                    padding="0px"
                    borderRadius={2}
                    headerContent={
                        <Fragment>
                            <Box display="flex" justifyContent="space-between" padding={2}>
                                <Box display="flex" gap={1}>
                                    <CommonButton
                                        label={CoachType.Assign}
                                        width="160px"
                                        fontWeight={600}
                                        height="35px"
                                        color={coachType === CoachType.Assign ? theme.palette.secondary.main : theme.palette.background.dark}
                                        background={coachType === CoachType.Assign ? theme.palette.primary.main : '#FAFAFA'}
                                        handleClick={() => setCoachType(CoachType.Assign)}
                                        marginBottom="0px"
                                    />
                                    <CommonButton
                                        label={CoachType.AI}
                                        width="200px"
                                        height="35px"
                                        fontWeight={600}
                                        color={coachType === CoachType.AI ? theme.palette.secondary.main : theme.palette.background.dark}
                                        background={coachType === CoachType.AI ? theme.palette.primary.main : '#FAFAFA'}
                                        handleClick={() => setCoachType(CoachType.AI)}
                                        marginBottom="0px"
                                    />
                                </Box>
                                {coachType === CoachType.Assign && (
                                    <Box
                                        sx={{
                                            background: '#C9F6E9',
                                            textAlign: 'center',
                                            height: 25,
                                            width: 60,
                                            borderRadius: 1,
                                            paddingTop: 0.3,
                                        }}
                                    >
                                        <Typography fontSize={13} fontWeight={600} color="#01875F">Active</Typography>
                                    </Box>
                                )}
                            </Box>
                            <Divider />
                        </Fragment>
                    }
                    content={
                        coachType === CoachType.Assign ? (
                            <Box p={2} display="flex" justifyContent="space-between">
                                <Box display="flex" gap={3} width="80%">
                                    <Box
                                        sx={{
                                            position: 'relative',
                                            width: '20%',
                                            minWidth: '120px',
                                            height: 'fit-content'
                                        }}
                                    >
                                        <img
                                            src={previewUrl || `https://ui-avatars.com/api/?name=${encodeURIComponent(`${coachData?.mentor?.user?.first_name} ${coachData?.mentor?.user?.last_name}`)}&background=FAFAFAf1&color=fff`}
                                            alt="profile"
                                            style={{
                                                width: '100%',
                                                height: 'auto',
                                                display: 'block',
                                                borderRadius: '8px'
                                            }}
                                        />
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                top: '-7px',
                                                right: '-20px',
                                                backgroundColor: 'red',
                                                color: 'white',
                                                padding: '2px 10px',
                                                borderRadius: '12px',
                                                fontSize: '11px',
                                                fontWeight: 'bold',
                                                zIndex: 10
                                            }}
                                        >
                                            Human
                                        </Box>
                                    </Box>
                                    <Box>
                                        <Typography fontWeight={600} fontSize={20}>
                                            {coachData?.mentor?.user?.first_name || coachData?.mentor?.user?.last_name
                                                ? `${coachData.mentor.user.first_name || ''} ${coachData.mentor.user.last_name || ''}`.trim()
                                                : 'Name not available'}
                                        </Typography>
                                        <Stack direction="row" alignItems="center" spacing={1} mt={0.5}>
                                            <Typography color="secondary.main" sx={{ fontSize: 14 }}>
                                                {coachData?.mentor?.degree || 'Degree not specified'}
                                            </Typography>
                                        </Stack>
                                        <Typography mt={0.5} color="background.dark">
                                            {coachData?.mentor?.experience_years
                                                ? `${ExpierienceYears?.find((a) => a.value === coachData.mentor.experience_years)?.label || ''} Experience`
                                                : 'Experience not specified'}
                                        </Typography>
                                        <Typography mt={1} color="background.dark" fontSize={14}>Subject Expertise</Typography>
                                        <Box display="flex" gap={1} mt={0.5} flexWrap="wrap">
                                            {coachData?.mentor?.expertise?.length > 0 ? (
                                                coachData.mentor.expertise.map((a, index) => (
                                                    <Box key={index} sx={{ background: '#EFF6FF', p: '4px 16px', borderRadius: 2 }}>
                                                        <Typography color="secondary.main">{a}</Typography>
                                                    </Box>
                                                ))
                                            ) : (
                                                <Typography color="text.secondary" fontSize={14}>No expertise listed</Typography>
                                            )}
                                        </Box>
                                    </Box>
                                </Box>
                                {!fromMentor && (
                                    <Box display="flex" gap={1}>
                                        <CommonButton
                                            label="Message"
                                            height="30px"
                                            width="120px"
                                            color="white"
                                            background={theme.palette.secondary.main}
                                            startIcon={<ChatBubbleOutlineOutlined style={{ fontSize: '15px' }} />}
                                            fontWeight={600}
                                            handleClick={async () => {
                                                try {
                                                    dispatch(setLoading({
                                                        loading: true
                                                    }));
                                                    const response = await joinConversation({
                                                        "student_id": user?.user_id,
                                                        "mentor_id": coachData?.mentor?.user_id
                                                    });
                                                    if (response.success) {
                                                        navigate(`/chat?id=${coachData?.mentor?.user_id}`)
                                                        dispatch(setLoading({
                                                            loading: false
                                                        }));
                                                    }
                                                } catch (err) {
                                                    const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
                                                    showNotification(errorMessage, 'error');
                                                    dispatch(setLoading({
                                                        loading: false
                                                    }));
                                                }
                                            }}
                                        />
                                        <CommonBookSession
                                            bookingUrl={coachData?.mentor?.calendly_meeting_link}
                                            open={open}
                                            setOpen={setOpen}
                                            studentName={`${user?.first_name} ${user?.last_name}`}
                                            email={user?.email}
                                            handleClose={(data) => {
                                                setOpen(false);
                                                setInitialData(data);
                                            }}
                                        />
                                        {user?.user_type_id === UserTypeId.Student && (
                                        <CommonButton
                                            label="Book a Session"
                                            height="30px"
                                            width="150px"
                                            fontWeight={600}
                                            handleClick={() => {
                                                setOpen(true)
                                            }}
                                        />)}
                                    </Box>)}
                            </Box>) : (
                            <Box p={2} display="flex" justifyContent="space-between">
                                <Box display="flex" gap={3} width="80%">
                                    <Box
                                        sx={{
                                            position: 'relative',
                                            width: '10%',
                                            minWidth: '120px',
                                            height: 'fit-content'
                                        }}
                                    >
                                        <img
                                            src="/Images/customersupport.png"
                                            alt="profile"
                                            style={{
                                                width: '100%',
                                                height: 'auto',
                                                display: 'block',
                                                borderRadius: '8px',
                                                border: '1px solid lightgray'
                                            }}
                                        />
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                top: '-7px',
                                                right: '-15px',
                                                backgroundColor: 'red',
                                                color: 'white',
                                                padding: '2px 10px',
                                                borderRadius: '12px',
                                                fontSize: '11px',
                                                fontWeight: 'bold',
                                                zIndex: 10
                                            }}
                                        >
                                            AI
                                        </Box>
                                    </Box>
                                    <Box>
                                        <Typography fontWeight={600} fontSize={20}>DCP AI Project Mentor</Typography>
                                        <Typography mt={0.5} mb={4} color="background.dark">Your personal AI teacher that helps you learn, practice, and understand any topic</Typography>
                                        {!fromMentor && (<CommonButton
                                            label="Chat"
                                            height="30px"
                                            width="80px"
                                            color="white"
                                            background={theme.palette.secondary.main}
                                            marginBottom="0px"
                                            startIcon={<ChatBubbleOutlineOutlined style={{ fontSize: '15px' }} />}
                                            handleClick={() => navigate('/ai-Chat?type=mentor')}
                                        />)}
                                    </Box>
                                </Box>
                            </Box>
                        )
                    }
                />
            </Fragment>
        ) : (
            <Box
                sx={{
                    mt: 2,
                    height: '30vh',
                    background: '#7A869126',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 2
                }}
            >
                <Typography color={theme.palette.background.dark}>You have not taken DCP Mentor Service</Typography>
                {user?.user_type_id === UserTypeId.Student && (
                <CommonButton
                    label="Find a Mentor"
                    fontWeight={600}
                    width="150px"
                    marginTop={1.5}
                    handleClick={() => navigate(`/book-session?type=mentor&pid=${projectData?.project_id}`)}
                />)}
            </Box>
        )
    )
}

export default Tutor;